import type { FC, ReactElement } from 'react';

import { useLegacyContext } from '../../components/legacyMode/LegacyContextProvider';
import { useMasterVolumeControl, useVolumeControl } from '../../store/slices/settings/hooks/useVolumeControl';
import { useSettingsSlice } from '../../store/slices/settings/selectors';
import { useIsLegacyDesktop } from '../../styles/hooks/legacyMedia';
import { ControlContainer } from '../controls/controlContainer/ControlContainer';
import { VolumeSlider } from '../controls/volumeSlider/VolumeSlider';

export interface VolumeChannelControlType {
  channel: string;
  label: ReactElement;
  description?: ReactElement;
  disabledWithStream?: boolean;
}

export const VolumeChannelControlConnected: FC<VolumeChannelControlType> = ({
  channel,
  description,
  disabledWithStream,
  label,
}): ReactElement | null => {
  const volumeControl = useVolumeControl(channel);
  const masterVolumeControl = useMasterVolumeControl();

  const noVolumeControl = useSettingsSlice.getNoVolumeControl();
  const allIsMuted = useSettingsSlice.getAllIsMutedCheck();
  const isStreamEnabled = useSettingsSlice.getIsStreamEnabled();
  const { isLegacyMode } = useLegacyContext();
  const isLegacyDesktop = useIsLegacyDesktop();
  const showOffset = !isLegacyMode || !isLegacyDesktop;

  if (!volumeControl) return null;
  return (
    <ControlContainer label={label} offset={showOffset} description={description}>
      <VolumeSlider
        allIsMuted={allIsMuted}
        control={volumeControl}
        disabled={disabledWithStream ? !isStreamEnabled : false}
        masterVolume={masterVolumeControl.value}
        noVolumeControl={noVolumeControl}
      />
    </ControlContainer>
  );
};
